<script>
export default {
  props: {
    title: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="border border-gray-500 rounded-sm">
    <div v-if="title" class="py-4 px-3">
      <h4 class="font-medium">{{ title }}</h4>
    </div>
    <div class="bg-gray-100 px-3 py-4">
      <slot />
    </div>
  </div>
</template>
